"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubModeGestionUtiliseCorporationTrads = void 0;
exports.ESubModeGestionUtiliseCorporationTrads = {
    conseillee: "Gestion conseillée",
    direct: "Gestion directe",
    sous_mandat: "Gestion sous mandat",
};
